import { api } from "@api/api";
import { AgreementIntegrationConfig } from "@modules/erpIntegrations/types";

import { ConfigPatchPayload } from "./types";

export async function editConfigService(
  id: string,
  data: ConfigPatchPayload
): Promise<AgreementIntegrationConfig> {
  // Mirror createConfigService's defensive behavior: never send
  // plan_map_option: null on the wire. There is currently no "clear mapping"
  // UI control, so a null value here is always an edge case (e.g. the row
  // this edit form was opened with was missing the field) rather than an
  // explicit intent to wipe the config's existing plan mapping.
  const { plan_map_option, ...rest } = data;
  const payload: ConfigPatchPayload = {
    ...(plan_map_option === null ? rest : data),
    test_document: (data.test_document ?? "").replace(/\D/g, ""),
  };

  const { data: config } = await api.patch<AgreementIntegrationConfig>(
    `/v1/agreement_integration_config_admin/${id}/`,
    payload
  );

  return config;
}
